export default __webpack_public_path__ + "static/media/color-colorless.5ca19998.webp";